/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import SelectReportOnStep from 'modules/report-builder/select-report-on-step';
import DataStep from 'modules/report-builder/data-step';
import VisualizationStep from 'modules/report-builder/visualization-step';
import { resetReportBuilder } from 'state/ui/report-builder/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const steps = {
	'1': SelectReportOnStep,
	'2': DataStep,
	'3': VisualizationStep,
};

const ReportBuilder = ({ reportId, report, ...props }) => {
	const [currentStep, setCurrentStep] = useState(1);

	useEffect(() => {
		let config = (report && report.config) || {};

		if (config.dataType && config.dataSet) {
			setCurrentStep(2);
		}

		return () => {
			props.resetReportBuilder();
		};
	}, [reportId]);

	const goToStep = (step) => {
		setCurrentStep(step);
	};

	const goToNextStep = () => {
		setCurrentStep(currentStep + 1);
	};

	const CurrentComponent = steps[currentStep];
	return (CurrentComponent && <CurrentComponent goToStep={goToStep} goToNextStep={goToNextStep} />) || null;
};

export default connect(null, { resetReportBuilder })(ReportBuilder);
